import { EditIcon } from "@/components/icons";
import CopyPlayerIframeCode from "@/components/player/widget/CopyPlayerIframeCode";
import AppContext from "@/context/AppContext";
import { updateFilterConfig, usePlayerPlaylist } from "@/lib/api";
import { futuraNextCondensedExtraBold } from "@/styles/fonts";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Button, ButtonGroup, Grid, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useContext, useEffect, useState } from "react";
import TextFieldStyled from "./TextFieldStyled";
import PlayerIframe from "./player/widget/PlayerIframe";

export default function ModalSharePlaylist({
  urlPlaylist,
  playlist,
  playlistType = "playlist",
  allowEditPlaylistName = false,
}) {
  const { setSnackbar } = useContext(AppContext);
  const [editPlaylistName, setEditPlaylistName] = useState(false);
  const { playlist: embeddablePlaylist, mutate: mutateEmbeddablePlaylist } =
    usePlayerPlaylist(playlistType, playlist.id);
  const [filterName, setFilterName] = useState(
    embeddablePlaylist?.title ?? playlist.title,
  );
  const [refreshIframe, setRefreshIframe] = useState(0);

  useEffect(() => {
    if (!embeddablePlaylist) {
      return;
    }

    setFilterName(embeddablePlaylist.title);
  }, [embeddablePlaylist]);

  const handlePlaylistClick = async () => {
    navigator.clipboard.writeText(urlPlaylist);
    setSnackbar("Link zur Playlist in die Zwischenablage kopiert");
  };

  const handleEditPlaylistName = () => {
    setEditPlaylistName(!editPlaylistName);
  };

  const handleFilterNameChanged = (e) => {
    setFilterName(e.target.value);
  };

  const updateFilter = () => {
    updateFilterConfig(embeddablePlaylist.id, { title: filterName }).then(
      async () => {
        await mutateEmbeddablePlaylist();
        setRefreshIframe((prev) => prev + 1);
        setSnackbar("Filter aktualisiert");
      },
    );
    setEditPlaylistName(false);
  };

  return (
    <>
      <Typography
        variant="h6"
        component="p"
        color="common.black"
        sx={{ fontFamily: futuraNextCondensedExtraBold.style.fontFamily }}
      >
        Aktuelle Playlist teilen
      </Typography>
      <Grid container spacing={1}>
        <Grid item xs={12} md={8}>
          <TextFieldStyled readonly={true} value={urlPlaylist} />
        </Grid>
        <Grid item xs={12} md={4}>
          <Button
            fullWidth
            variant="contained"
            color="secondary"
            onClick={handlePlaylistClick}
            sx={{ marginTop: "0.25rem" }}
          >
            Link kopieren
          </Button>
        </Grid>
      </Grid>
      <Typography
        variant="h6"
        component="p"
        color="common.black"
        sx={{
          fontFamily: futuraNextCondensedExtraBold.style.fontFamily,
          marginBottom: allowEditPlaylistName ? "0" : "0.5rem",
        }}
      >
        Playlist einbetten
      </Typography>
      <Grid container spacing={1}>
        {allowEditPlaylistName && (
          <>
            <Grid item xs>
              <TextFieldStyled
                readonly={!editPlaylistName}
                value={filterName}
                onChange={handleFilterNameChanged}
                helpertext="Dies ist der Name deiner Playlist"
              />
            </Grid>
            <Grid item xs="auto" sx={IconButtonStyles}>
              <ButtonGroup variant="contained" sx={{ gap: ".125rem" }}>
                {editPlaylistName ? (
                  <>
                    <IconButton
                      color="primary"
                      aria-label="Abbrechen"
                      onClick={handleEditPlaylistName}
                    >
                      <CloseIcon />
                    </IconButton>
                    <IconButton
                      color="secondary"
                      aria-label="Speichern"
                      onClick={updateFilter}
                    >
                      <CheckIcon />
                    </IconButton>
                  </>
                ) : (
                  <IconButton
                    color="secondary"
                    aria-label="Playlist bearbeiten"
                    onClick={handleEditPlaylistName}
                  >
                    <EditIcon />
                  </IconButton>
                )}
              </ButtonGroup>
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <CopyPlayerIframeCode
            playlistType={playlistType}
            playlistId={embeddablePlaylist?.id}
          />
        </Grid>
        <Grid item xs={12}>
          {embeddablePlaylist && (
            <>
              <PlayerIframe
                type={playlistType}
                id={embeddablePlaylist?.id}
                refresh={refreshIframe}
                cache={false}
              />
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
}

const IconButtonStyles = {
  "& .MuiIconButton-root": {
    marginTop: "0.25rem",
    width: "2.65625rem !important",
    height: "2.65625rem !important",
  },
};
